import React, { useState } from 'react';

import ItemSelector from './ItemSelector';
import SpinLoader from '../shared/SpinLoader';

const EditItem = ({
    exlCallBack,
    iconName,
    value: item,
    setValue: setItem,
    getSuggestions,
    placeHolder,
    isCreationPermitted,
    onKeyDown,
    isInvalid,
    onSave,
    isClearable,
    autoFocus,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [userInput, setUserInput] = useState('');
    
    return (
        <div className='crm-editable-field-wrapper'>
            <div className={`input-wrapper ${isInvalid ? 'invalid' : ''}`}>
                <ItemSelector
                    {...{
                        exlCallBack,
                        iconName,
                        userInput,
                        setUserInput,
                        item,
                        setItem,
                        placeHolder,
                        setIsLoading,
                        onKeyDown,
                        getSuggestions,
                        isCreationPermitted,
                        onSave,
                        isClearable,
                        autoFocus,
                    }}
                />
                <SpinLoader isLoading={isLoading} />
            </div>
        </div>
    );
};

export default EditItem;
